export default __webpack_public_path__ + "static/media/pltr.6f547aee.svg";